import React, { useState } from "react";

import PretendardText from "../../atoms/text/pretendardText";
import MainInput from "../../atoms/input/mainInput";
import Popup from "../../molecules/popup";

import PopupOverLay from "../PopupOverlay";
import TableText from "../../atoms/text/table/tableText";
import Radio from "../../atoms/input/radio";
import { toast } from "react-toastify";
import OrderApi from "../../../api/order.api";
import { errorHandler } from "../../../util/errorHandler";
import moment from "moment";

const CancelApprovePopup = ({ setPopupOpen, sellData, getSellList }) => {
  // ---------- 취소 승인 처리 관련 ---------- //
  const [selectedAmountType, setSelectedAmountType] = useState("FULL");

  const [refundAmount, setRefundAmount] = useState("");

  function isNumericString(str) {
    const regex = /^\d+$/;
    return regex.test(str);
  }

  const rejectRequestFunc = async () => {
    try {
      if (selectedAmountType === "PARTIAL") {
        if (refundAmount === "") return toast("부분 취소 금액을 입력해주세요.");

        if (!isNumericString(String(refundAmount))) {
          return toast("숫자만 입력가능합니다");
        }
      }

      const data = {
        refundAllFlag: refundAmount === "" ? true : false,
        refundAmount:
          refundAmount === "" ? Number(sellData.realPay) : Number(refundAmount),
      };

      await OrderApi.updateCancelComplete(sellData.id, data);

      toast("취소 승인되었습니다.");
      setPopupOpen(false);
      getSellList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <PopupOverLay
        isOpen={true}
        onClick={() => {
          setPopupOpen(false);
        }}
      >
        <Popup
          headerTitle="취소 승인 처리"
          footerBtnText="확인"
          onClick={() => {
            setPopupOpen(false);
          }}
          footerBtnHandler={() => {
            rejectRequestFunc();
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: 32,
            }}
          >
            <table
              style={{
                width: "100%",
                borderSpacing: 0,
                borderCollapse: "collapse",
              }}
            >
              <colgroup>
                {/* 합계: 630px */}
                {/* 구매번호 */}
                <col width="162px" />
                {/* 상품명 */}
                <col width="272px" />
                {/* 상태*/}
                <col width="76px" />
                {/* 취소 요청일 */}
                <col width="120px" />
              </colgroup>
              <thead>
                <tr
                  style={{
                    height: 41,
                    borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  <th
                    style={{
                      paddingLeft: 30,
                    }}
                  >
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      구매번호
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      상품명
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      상태
                    </TableText>
                  </th>
                  <th>
                    <TableText
                      style={{
                        fontWeight: "600",
                        lineHeight: "22.75px",
                      }}
                    >
                      취소 요청일
                    </TableText>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  style={{
                    height: 46,
                  }}
                >
                  <td>
                    <TableText
                      style={{
                        paddingLeft: 30,
                      }}
                    >
                      {sellData.payNumber}
                    </TableText>
                  </td>
                  <td>
                    <TableText>{sellData.orderTitle}</TableText>
                  </td>
                  <td>
                    <TableText>
                      {sellData.orderStatus === "PAY_COMPLETE"
                        ? "결제 완료"
                        : sellData.orderStatus === "CANCEL_REQUEST"
                        ? "취소 요청"
                        : sellData.orderStatus === "CANCEL_REJECT"
                        ? "취소 거절"
                        : sellData.orderStatus === "CANCEL_COMPLETE"
                        ? "취소 완료"
                        : ""}
                    </TableText>
                  </td>
                  <td>
                    <TableText>
                      {moment(sellData.cancelRequestDate).format("YYYY-MM-DD")}
                    </TableText>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "0px 30px",
                marginTop: 20,
              }}
            >
              <PretendardText
                style={{
                  fontWeight: 500,
                  fontSize: 15,
                  lineHeight: "21.5px",
                  color: "#aaa",
                }}
              >
                취소 금액
              </PretendardText>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 24,
                  margin: "12px 0px 16px 0px",
                }}
              >
                <Radio
                  id={""}
                  valueText={"전액 취소"}
                  checked={selectedAmountType === "FULL"}
                  onChange={() => {
                    setSelectedAmountType("FULL");
                  }}
                />
                <Radio
                  id={""}
                  valueText={"부분 취소"}
                  checked={selectedAmountType === "PARTIAL"}
                  onChange={() => {
                    setSelectedAmountType("PARTIAL");
                  }}
                />
              </div>
              {selectedAmountType === "PARTIAL" && (
                <>
                  <MainInput
                    type={"text"}
                    placeholder={"부분 취소 금액"}
                    style={{
                      width: "338px",
                    }}
                    value={refundAmount}
                    onChange={(e) => {
                      setRefundAmount(e.target.value);
                    }}
                  />
                  <PretendardText
                    style={{
                      fontWeight: 500,
                      fontSize: 13,
                      lineHeight: "18.75px",
                      color: "rgba(181, 181, 181, 0.5)",
                      marginTop: 16,
                    }}
                  >
                    실 결제 금액에서 부분 취소 금액을 빼고 환불됩니다
                  </PretendardText>
                </>
              )}
            </div>
          </div>
        </Popup>
      </PopupOverLay>
    </>
  );
};

export default CancelApprovePopup;
